// AYNI Calendar Design System — inline styles matching AYNI design tokens
const calendarStyles = {
  // Navigation bar
  navBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '16px',
    gap: '10px',
  },
  navLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  navRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  navButton: {
    padding: '6px 14px',
    backgroundColor: 'var(--bg-button-secondary)',
    color: 'var(--text-secondary)',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '500',
    cursor: 'pointer',
    height: '34px',
    display: 'flex',
    alignItems: 'center',
  },
  todayButton: {
    padding: '6px 14px',
    backgroundColor: 'var(--color-primary)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '500',
    cursor: 'pointer',
    height: '34px',
    display: 'flex',
    alignItems: 'center',
  },
  monthLabel: {
    fontSize: '18px',
    fontWeight: '600',
    color: 'var(--text-primary)',
    margin: 0,
    textAlign: 'center',
    minWidth: '200px',
  },

  // Calendar card wrapper
  calendarCard: {
    backgroundColor: 'var(--bg-card)',
    borderRadius: '12px',
    boxShadow: 'var(--shadow-card)',
    border: '1px solid var(--border-default)',
    overflow: 'hidden',
  },

  // Grid
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },

  // Weekday header
  weekdayCell: {
    padding: '10px 4px',
    textAlign: 'center',
    fontSize: '11px',
    fontWeight: '600',
    color: 'var(--text-muted)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: '1px solid var(--border-default)',
    backgroundColor: 'var(--bg-table-header)',
  },

  // Day cells
  dayCell: {
    minHeight: '90px',
    padding: '4px',
    borderRight: '1px solid var(--border-light)',
    borderBottom: '1px solid var(--border-light)',
    position: 'relative',
    backgroundColor: 'var(--bg-card)',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
  },
  dayCellOutside: {
    minHeight: '90px',
    padding: '4px',
    borderRight: '1px solid var(--border-light)',
    borderBottom: '1px solid var(--border-light)',
    position: 'relative',
    backgroundColor: 'var(--bg-table-header)',
    cursor: 'default',
  },
  dayCellEmpty: {
    backgroundColor: 'var(--bg-gap)',
  },
  dayNumber: {
    fontSize: '12px',
    fontWeight: '500',
    color: 'var(--text-tertiary)',
    marginBottom: '2px',
    display: 'inline-block',
    padding: '2px 4px',
  },
  dayNumberOutside: {
    fontSize: '12px',
    fontWeight: '400',
    color: 'var(--text-placeholder)',
    marginBottom: '2px',
    display: 'inline-block',
    padding: '2px 4px',
  },
  dayNumberToday: {
    fontSize: '12px',
    fontWeight: '700',
    color: 'white',
    backgroundColor: 'var(--color-primary)',
    borderRadius: '50%',
    width: '24px',
    height: '24px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '2px',
  },

  // Legend
  legend: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '12px',
    flexWrap: 'wrap',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '12px',
    color: 'var(--text-tertiary)',
  },
  legendSwatch: {
    width: '14px',
    height: '14px',
    borderRadius: '4px',
    flexShrink: 0,
  },
};

// Status color map (matches badge colors in PropertyDetails)
export const statusColors = {
  ACTIVE: { bg: '#86efac', text: '#14532d', border: '#22c55e' },
  FUTURE: { bg: '#93c5fd', text: '#1e3a8a', border: '#3b82f6' },
  BLOCKED: { bg: '#fca5a5', text: '#7f1d1d', border: '#ef4444' },
  INACTIVE: { bg: '#d1d5db', text: '#374151', border: '#9ca3af' },
};

export default calendarStyles;
